import { Result } from 'domain/types';
import Layout from 'domain/entity/layout';
import ReadLayoutsClient from 'use-case/layout/read/readLayoutsClient';
import ReadLayoutsCriteria from 'use-case/layout/read/readLayoutsCriteria';

export type ReadLayoutsResult = Result<Layout[]>;
export type ReadLayouts = (criteria: ReadLayoutsCriteria) => Promise<ReadLayoutsResult>;

export default (readLayoutsClient: ReadLayoutsClient): ReadLayouts => (criteria: ReadLayoutsCriteria): Promise<ReadLayoutsResult> =>
    readLayoutsClient(criteria);
